<template>
  <div
    role="dialog"
    class="modal modal-drawer-list-scroll fade fixed-end"
    aria-modal="true"
  >
    <div
      role="document"
      class="modal-dialog modal-dialog-vertical dw-11 dw-md-8 dw-lg-6 dw-xl-4"
    >
      <validation-observer tag="div" class="modal-content" @submit.native.prevent ref="validation">
        <div class="modal-header">
          <h2 class="modal-title">Add Camera</h2>
          <button
            type="button"
            data-bs-dismiss="modal"
            aria-label="Close"
            class="btn-close"
          ></button>
        </div>

        <div class="modal-body pt-0 pb-0 flex-grow-1">
          <div class="mt-3 mb-2">
            <validation-provider name="name" vid="name">
              <label class="form-label">Name</label>
              <c-input type="text" v-model="name"/>
              <c-help-block />
            </validation-provider>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            data-bs-dismiss="modal"
            class="btn btn-outline-info"
          >
            Close
          </button>
          <c-button
            type="button"
            class="btn btn-primary"
            @click="handleSave"
          >
            Add Camera
          </c-button>
        </div>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import { helperComputed, helperMethods } from '@/vuex/modules/screens/cameras'
import { CModal } from '@chameleon/chameleon-vue'

export default {
  extends: CModal,

  mixins: [],

  components: {
  },

  data () {
    return {
      name: ''
    }
  },

  async mounted () {
    this.addEventListener('open', async () => {
      this.name = ''
    })

    this.addEventListener('close', async () => {
      this.name = ''
    })
  },

  computed: {
    ...helperComputed,
  },

  methods: {
    ...helperMethods,

    async handleSave () {
      await this.storeCamera({ name: this.name })
      await this.getCameras()
      this.close()
    },
  }
}
</script>
